import { render, staticRenderFns } from "./ToDeliver.vue?vue&type=template&id=70197086&scoped=true"
import script from "./ToDeliver.vue?vue&type=script&lang=js"
export * from "./ToDeliver.vue?vue&type=script&lang=js"
import style0 from "./ToDeliver.vue?vue&type=style&index=0&id=70197086&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70197086",
  null
  
)

export default component.exports